module.exports = __webpack_public_path__ + "static/media/icon2@2x.7af338cd.png";